var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankStatement = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 302,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.936 20.035l202.01-.062a2 2 0 0 1 2 2l-.08 257.824a2 2 0 0 1-1.999 2l-202.009.062a2 2 0 0 1-2-2l.08-257.823a2 2 0 0 1 1.998-2z",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.32.399h5.391c.95 0 1.719.769 1.719 1.718v.697c0 .95-.77 1.719-1.719 1.719H25.32c-.95 0-1.719-.77-1.719-1.72v-.696c0-.949.77-1.718 1.719-1.718zm1.471 8.268h3.92c.95 0 1.719.77 1.719 1.719v.696c0 .95-.77 1.719-1.719 1.719h-3.92c-.949 0-1.718-.77-1.718-1.719v-.696c0-.95.769-1.72 1.718-1.72zm-2.943 8.268h6.863c.95 0 1.719.77 1.719 1.719v.697c0 .949-.77 1.718-1.719 1.718h-6.863c-.949 0-1.718-.77-1.718-1.718v-.697c0-.95.77-1.719 1.718-1.719zM2.104.4h10.088c.949 0 1.718.769 1.718 1.718v.697c0 .95-.77 1.719-1.718 1.719H2.104c-.95 0-1.72-.77-1.72-1.72v-.696c0-.949.77-1.718 1.72-1.718zm0 8.268h6.03c.95 0 1.719.77 1.719 1.719v.696c0 .95-.77 1.719-1.72 1.719h-6.03c-.949 0-1.718-.77-1.718-1.719v-.696c0-.95.77-1.72 1.719-1.72zm0 8.268h11.44c.95 0 1.719.77 1.719 1.719v.697c0 .949-.77 1.718-1.719 1.718H2.104c-.95 0-1.72-.77-1.72-1.718v-.697c0-.95.77-1.719 1.72-1.719z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.381 45.128L211.164.6a2 2 0 0 1 2.374 1.541l53.424 252.193a2 2 0 0 1-1.54 2.37L56.64 301.235a2 2 0 0 1-2.374-1.542L.842 47.499a2 2 0 0 1 1.54-2.37z",
    fill: "#CCCCD9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.152 14.576l213.155 11.21a2 2 0 0 1 1.893 2.102l-13.446 257.476a2 2 0 0 1-2.102 1.893l-213.156-11.21a2 2 0 0 1-1.892-2.102L32.05 16.468a2 2 0 0 1 2.102-1.893z",
    fill: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5 133.902 150.916)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,.12)",
    strokeWidth: 1,
    d: "M31.936 19.207v-.172l203.009-.062a3 3 0 0 1 3 3v.001l-.079 257.823a3 3 0 0 1-2.999 3l-202.008.062a3 3 0 0 1-3.001-2.999v-.001l.08-257.824c0-1.305.834-2.416 1.998-2.828z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.218 93.579l30.095-2.633a1.719 1.719 0 0 1 1.862 1.562l.06.694a1.719 1.719 0 0 1-1.562 1.862L38.58 97.697a1.719 1.719 0 0 1-1.862-1.562l-.061-.694a1.719 1.719 0 0 1 1.562-1.862zm.72 8.237l52.442-4.588a1.719 1.719 0 0 1 1.862 1.562l.06.694a1.719 1.719 0 0 1-1.562 1.862l-52.44 4.588a1.719 1.719 0 0 1-1.863-1.562l-.06-.694a1.719 1.719 0 0 1 1.562-1.862zm.722 8.237l35.68-3.122a1.719 1.719 0 0 1 1.863 1.562l.06.694a1.719 1.719 0 0 1-1.562 1.862l-35.681 3.122a1.719 1.719 0 0 1-1.862-1.562l-.06-.694a1.719 1.719 0 0 1 1.562-1.862z",
    fill: "#A6A6CC",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5 1604.286 -399.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F66",
    opacity: 0.4,
    x: 5.633,
    y: 4.189,
    width: 33.796,
    height: 3.656,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DBDBEB",
    x: 5.633,
    y: 18.153,
    width: 22.531,
    height: 4.189,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DBDBEB",
    x: 5.633,
    y: 32.117,
    width: 33.796,
    height: 4.189,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F66",
    opacity: 0.4,
    x: 83.082,
    y: 4.189,
    width: 33.796,
    height: 3.656,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DBDBEB",
    x: 108.429,
    y: 18.153,
    width: 8.449,
    height: 4.189,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DBDBEB",
    x: 107.021,
    y: 32.117,
    width: 9.857,
    height: 4.189,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4F4F66",
    opacity: 0.4,
    x: 161.94,
    y: 4.189,
    width: 15.49,
    height: 3.656,
    rx: 1.719
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.444 17.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#7ED321",
    y: 0.433,
    width: 10.3,
    height: 5.742,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "GTAmerica-Medium, GT America",
    fontSize: 4,
    fontWeight: 400,
    fill: "#417505"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.024,
    y: 4.371
  }, "$"))), /*#__PURE__*/React.createElement("rect", {
    fill: "#7ED321",
    x: 158.147,
    y: 32.26,
    width: 10.3,
    height: 5.742,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "GTAmerica-Medium, GT America",
    fontSize: 4,
    fontWeight: 400,
    fill: "#417505"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 172.497,
    y: 36.67
  }, "$")), /*#__PURE__*/React.createElement("rect", {
    stroke: "#30186D",
    opacity: 0.4,
    x: -0.5,
    y: -0.5,
    width: 184.062,
    height: 59.649,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.704 13.266h181.654",
    stroke: "#30186D",
    opacity: 0.4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30186D",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "M0 0v12.568h183.062V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.704 27.23h181.654M.704 41.194h181.654",
    stroke: "#30186D",
    opacity: 0.4,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.283 43.984l30.094-2.633a1.719 1.719 0 0 1 1.862 1.563l.061.694a1.719 1.719 0 0 1-1.562 1.862l-30.095 2.633a1.719 1.719 0 0 1-1.862-1.563l-.06-.694a1.719 1.719 0 0 1 1.562-1.862zm-21.626 10.192l52.441-4.588a1.719 1.719 0 0 1 1.862 1.563l.06.694a1.719 1.719 0 0 1-1.562 1.862l-52.44 4.587a1.719 1.719 0 0 1-1.862-1.562l-.061-.694a1.719 1.719 0 0 1 1.562-1.862zm17.48 6.77l35.682-3.121a1.719 1.719 0 0 1 1.862 1.562l.06.694a1.719 1.719 0 0 1-1.562 1.862l-35.681 3.122a1.719 1.719 0 0 1-1.862-1.562l-.061-.694a1.719 1.719 0 0 1 1.562-1.862z",
    fill: "#A6A6CC",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5 2607.106 -2066.508)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#DBDBEB",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.382-3.57c-10.874-.275-21.765-1.474-32.624-.824-8.357.5-11.863 18.546-3.47 18.688 6.345.107 46.546 7.419 41.71-15.011-.29-1.347-2.26-1.567-3.391-2.35l-2.225-.503z",
    fill: "#FFF",
    opacity: 0.32,
    mask: "url(#d)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankStatement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bankStatement.86bc594dc5130c1a93a7519ccabcf5cc.svg";